export const CategoryActors = {
    TOGGLE_CATEGORY:'TOGGLE_CATEGORY',
    CATEGORY_LIST:'CATEGORY_LIST',
    INACTIVE_LIST:'INACTIVE_LIST',
    TOGGLE_INACTIVE_LIST:'TOGGLE_INACTIVE_LIST'
}